import type { ConfigurationPrerequisites } from '../AppsTiktokShop.types'

export const getConfigurationPrerequisitesErrors = (prerequisites?: ConfigurationPrerequisites) => {
  const prerequisitesKeys = Object.keys(prerequisites ?? {}) as (keyof ConfigurationPrerequisites)[]

  return prerequisitesKeys.reduce<string[]>((prev, key) => {
    const prerequisite = prerequisites?.[key]
    if (prerequisite?.type === 'NOT_COMPLETED' && prerequisite.message) {
      return [...prev, prerequisite.message]
    }

    return prev
  }, [])
}
